import React, { useContext, useMemo } from 'react'; // Removed useState, useEffect if not needed directly
import Select from 'react-select';
import { LocationsContext } from '../../LocationsContext'; // Make sure path is correct

// Define styles for react-select
const selectStyles = {
  container: (provided) => ({
    ...provided,
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 5
  }),
  control: (provided) => ({
    ...provided,
    borderRadius: '25px',
  }),
};

const LocationFilter = ({ filters, setFilters }) => {
  const { regions, cities } = useContext(LocationsContext);

  const selectedRegionValue = filters.region;
  // City is now expected to be an array of strings (IDs)
  const selectedCityValues = Array.isArray(filters.city) ? filters.city : []; // Ensure it's always an array

  const regionOptions = useMemo(() => {
    return regions.map((region) => ({
      value: region,
      label: region,
    }));
  }, [regions]);

  const filteredCityOptions = useMemo(() => {
    if (!selectedRegionValue || !cities) {
      return [];
    }
    return cities
      .filter((city) => city.region === selectedRegionValue)
      .map((city) => ({
        value: String(city.id), // Ensure value is string
        label: `${city.city} (${city.post_code})`,
      }));
  }, [selectedRegionValue, cities]);


  // --- Event Handlers ---

  const handleRegionChange = (selectedOption) => {
    const newRegionValue = selectedOption ? selectedOption.value : '';
    setFilters(prevFilters => {
      // No change optimization might be tricky with array reset, do it simply
      return {
        ...prevFilters,
        region: newRegionValue,
        // **CRITICAL: Reset city to an empty ARRAY when region changes/clears**
        city: [],
      };
    });
  };

  const handleCityChange = (selectedOptions) => {
    // selectedOptions will be an array of { value, label } objects or null/empty array
    const newCityValues = selectedOptions ? selectedOptions.map(option => option.value) : []; // Map to array of values (IDs)
    setFilters(prevFilters => {
      // Simple update, could add deep equality check if needed later
      return {
        ...prevFilters,
        // Set the array of city IDs
        city: newCityValues,
      };
    });
  };

  // --- Value calculation for Select components ---

  const currentRegionSelectValue = regionOptions.find(option => option.value === selectedRegionValue) || null;

  // Find the array of option objects for the current city values
  const currentCitySelectValues = filteredCityOptions.filter(
    option => selectedCityValues.includes(option.value)
  );


  // --- Render ---

  return (
    <div className="location-filter">
      <h3>Lokacija</h3>

      {/* Region Selector */}
      <Select
        inputId="region-select"
        options={regionOptions}
        value={currentRegionSelectValue}
        onChange={handleRegionChange}
        placeholder="Izberite regijo..."
        isClearable
        styles={selectStyles}
      />

      {/* Cities Selector (multi-select enabled) */}
      {selectedRegionValue && filteredCityOptions.length > 0 && (
        <div style={{ marginTop: '1rem' }}>
          <Select
            inputId="city-select"
            options={filteredCityOptions}
            value={currentCitySelectValues} // Pass the array of selected option objects
            onChange={handleCityChange}
            isMulti={true} // *** Re-enabled multi-select ***
            placeholder="Izberite kraj(e)..." // Updated placeholder
            isClearable
            styles={selectStyles}
          />
        </div>
      )}
    </div>
  );
};

export default LocationFilter;